export { default as A1 } from './A1.svg?react'
export { default as A2 } from './A2.svg?react'
export { default as A3 } from './A3.svg?react'
export { default as B1 } from './B1.svg?react'
export { default as B2 } from './B2.svg?react'
export { default as B3 } from './B3.svg?react'
export { default as C1 } from './C1.svg?react'
export { default as C2 } from './C2.svg?react'
export { default as C3 } from './C3.svg?react'
export { default as cursor_cross } from './cursor_cross.svg?react'
export { default as cursor_default } from './cursor_default.svg?react'
export { default as cursor_drag } from './cursor_drag.svg?react'
export { default as cursor_resize } from './cursor_resize.svg?react'
export { default as freePremiumCalendar } from './free-premium-calendar.svg?react'
export { default as achievement_analysis_sad } from './icon_achievement-analysis_sad.svg?react'
export { default as achievement_analysis_smile } from './icon_achievement-analysis_smile.svg?react'
export { default as add } from './icon_add.svg?react'
export { default as add_circle } from './icon_add_circle.svg?react'
export { default as add_file } from './icon_add_file.svg?react'
export { default as ai_comment_mono } from './icon_ai_comment_mono.svg?react'
export { default as ai_tutor_default } from './icon_ai_tutor.svg?react'
export { default as ai_tutor } from './icon_ai_tutor_blue.svg?react'
export { default as alert_info } from './icon_alert.svg?react'
export { default as alert_error_fill } from './icon_alert_error_fill.svg?react'
export { default as answer_check } from './icon_answer_check.svg?react'
export { default as answer_correct } from './icon_answer_correct.svg?react'
export { default as answer_question } from './icon_answer_question.svg?react'
export { default as answer_wrong } from './icon_answer_wrong.svg?react'
export { default as arrow_enter } from './icon_arrow_enter.svg?react'
export { default as assignment } from './icon_assignment.svg?react'
export { default as assignment_turned_in } from './icon_assignment_turned_in.svg?react'
export { default as bling } from './icon_bling.svg?react'
export { default as block } from './icon_block.svg?react'
export { default as book_opened } from './icon_book_opened.svg?react'
export { default as book_read } from './icon_book_read.svg?react'
export { default as bookmark_fill } from './icon_bookmark_fill.svg?react'
export { default as bookmark_line } from './icon_bookmark_line.svg?react'
export { default as calendar } from './icon_calendar.svg?react'
export { default as camera } from './icon_camera.svg?react'
export { default as chart } from './icon_chart.svg?react'
export { default as check } from './icon_check.svg?react'
export { default as check_circle } from './icon_check_circle.svg?react'
export { default as check_small } from './icon_check_small.svg?react'
export { default as chevron_double_right } from './icon_chevron_double_right.svg?react'
export { default as chevron_down } from './icon_chevron_down.svg?react'
export { default as chevron_left } from './icon_chevron_left.svg?react'
export { default as chevron_right } from './icon_chevron_right.svg?react'
export { default as chevron_up } from './icon_chevron_up.svg?react'
export { default as click } from './icon_click.svg?react'
export { default as clock } from './icon_clock.svg?react'
export { default as close } from './icon_close.svg?react'
export { default as close_circle } from './icon_close_circle.svg?react'
export { default as communication } from './icon_communication.svg?react'
export { default as content_cut } from './icon_content_cut.svg?react'
export { default as content_paste_outlined } from './icon_content_paste_outlined.svg?react'
export { default as copy } from './icon_copy.svg?react'
export { default as delete } from './icon_delete.svg?react'
export { default as description_paper } from './icon_description_paper.svg?react'
export { default as done_all } from './icon_done_all.svg?react'
export { default as download } from './icon_download.svg?react'
export { default as drag_handle } from './icon_drag_handle.svg?react'
export { default as dropdown_arrow_down } from './icon_dropdown_arrow_down.svg?react'
export { default as dropdown_arrow_right } from './icon_dropdown_arrow_right.svg?react'
export { default as dropdown_arrow_up } from './icon_dropdown_arrow_up.svg?react'
export { default as edit } from './icon_edit.svg?react'
export { default as edit_note } from './icon_edit_note.svg?react'
export { default as ellipse } from './icon_ellipse.svg?react'
export { default as erase } from './icon_erase.svg?react'
export { default as erase_v2 } from './icon_erase_v2.svg?react'
export { default as eye_closed } from './icon_eye_closed.svg?react'
export { default as eye_opened } from './icon_eye_opened.svg?react'
export { default as failure } from './icon_failure.svg?react'
export { default as file } from './icon_file.svg?react'
export { default as filter } from './icon_filter.svg?react'
export { default as folder_line } from './icon_folder_line.svg?react'
export { default as full_screen } from './icon_full_screen.svg?react'
export { default as goods } from './icon_goods.svg?react'
export { default as headset_mic } from './icon_headset_mic.svg?react'
export { default as help } from './icon_help.svg?react'
export { default as help_fill } from './icon_help_fill.svg?react'
export { default as help_line } from './icon_help_line.svg?react'
export { default as high_light } from './icon_high_light.svg?react'
export { default as highlight_pen } from './icon_highlight_pen.svg?react'
export { default as hyphen } from './icon_hyphen.svg?react'
export { default as info } from './icon_info.svg?react'
export { default as info_fill } from './icon_info_fill.svg?react'
export { default as inside_point } from './icon_inside_point.svg?react'
export { default as laboratory } from './icon_laboratory.svg?react'
export { default as line_add_circle } from './icon_line_add_circle.svg?react'
export { default as link_off } from './icon_link_off.svg?react'
export { default as list } from './icon_list.svg?react'
export { default as lock } from './icon_lock.svg?react'
export { default as lock_fill } from './icon_lock-fill.svg?react'
export { default as logo_block } from './icon_logo_block.svg?react'
export { default as mail } from './icon_mail.svg?react'
export { default as mail_opened } from './icon_mail_opened.svg?react'
export { default as mathflat } from './icon_mathflat.svg?react'
export { default as message } from './icon_message.svg?react'
export { default as monitoring } from './icon_monitoring.svg?react'
export { default as more_veritcal } from './icon_more_veritcal.svg?react'
export { default as move } from './icon_move.svg?react'
export { default as mylist } from './icon_mylist.svg?react'
export { default as mylist_fill } from './icon_mylist_fill.svg?react'
export { default as navigation } from './icon_navigation.svg?react'
export { default as navigation_arrow_right } from './icon_navigation_arrow_right.svg?react'
export { default as navigation_arrow_back } from './icon_navigation-arrow_back.svg?react'
export { default as navigation_lower_rank } from './icon_navigation-lower-rank.svg?react'
export { default as new_tag } from './icon_new_tag.svg?react'
export { default as new_tag_orange } from './icon_new_tag_orange.svg?react'
export { default as normal_screen } from './icon_normal_screen.svg?react'
export { default as notification } from './icon_notification.svg?react'
export { default as iconOne } from './icon_one.svg?react'
export { default as outlined_star } from './icon_outlined_star.svg?react'
export { default as outlined_upload } from './icon_outlined_upload.svg?react'
export { default as palette } from './icon_palette.svg?react'
export { default as paper } from './icon_paper.svg?react'
export { default as papers } from './icon_papers.svg?react'
export { default as pause } from './icon_pause.svg?react'
export { default as pause_circle } from './icon_pause_circle.svg?react'
export { default as pen } from './icon_pen.svg?react'
export { default as people } from './icon_people.svg?react'
export { default as person } from './icon_person.svg?react'
export { default as phone } from './icon_phone.svg?react'
export { default as photo_album } from './icon_photo_album.svg?react'
export { default as picture } from './icon_picture.svg?react'
export { default as play } from './icon_play.svg?react'
export { default as play_circle } from './icon_play_circle.svg?react'
export { default as playlist_add_check } from './icon_playlist_add_check.svg?react'
export { default as polygon } from './icon_polygon.svg?react'
export { default as premium_graphic } from './icon_premium_graphic.svg?react'
export { default as icon_preveal_answer } from './icon_preveal_answer.svg?react'
export { default as preview } from './icon_preview.svg?react'
export { default as print } from './icon_print.svg?react'
export { default as profile } from './icon_profile.svg?react'
export { default as purchase } from './icon_purchase.svg?react'
export { default as qr_scan } from './icon_qr_scan.svg?react'
export { default as redo } from './icon_redo.svg?react'
export { default as refresh } from './icon_refresh.svg?react'
export { default as remove } from './icon_remove.svg?react'
export { default as remove_circle } from './icon_remove_circle.svg?react'
export { default as remove_fill } from './icon_remove_fill.svg?react'
export { default as repeat } from './icon_repeat.svg?react'
export { default as report } from './icon_report.svg?react'
export { default as report_notification } from './icon_report_notification.svg?react'
export { default as reset } from './icon_reset.svg?react'
export { default as reset_size } from './icon_reset-size.svg?react'
export { default as return } from './icon_return.svg?react'
export { default as school } from './icon_school.svg?react'
export { default as screen_fit } from './icon_screen_fit.svg?react'
export { default as search } from './icon_search.svg?react'
export { default as settings } from './icon_settings.svg?react'
export { default as share } from './icon_share.svg?react'
export { default as shopping_bag } from './icon_shopping_bag.svg?react'
export { default as shopping_bag_fill } from './icon_shopping_bag_fill.svg?react'
export { default as shopping_cart } from './icon_shopping_cart.svg?react'
export { default as skip_back } from './icon_skip_back.svg?react'
export { default as skip_forward } from './icon_skip_forward.svg?react'
export { default as smile } from './icon_smile.svg?react'
export { default as speaker } from './icon_speaker.svg?react'
export { default as star } from './icon_star.svg?react'
export { default as star_fill } from './icon_star_fill.svg?react'
export { default as swap } from './icon_swap.svg?react'
export { default as swap_horiz } from './icon_swap_horiz.svg?react'
export { default as text } from './icon_text.svg?react'
export { default as thumb_down } from './icon_thumb_down.svg?react'
export { default as thumb_up } from './icon_thumb_up.svg?react'
export { default as iconTwo } from './icon_two.svg?react'
export { default as undo } from './icon_undo.svg?react'
export { default as unlock } from './icon_unlock_line.svg?react'
export { default as unlock_fill } from './icon_unlock-fill.svg?react'
export { default as unlock_line } from './icon_unlock-line.svg?react'
export { default as up_down_filter } from './icon_up_down_filter.svg?react'
export { default as upload } from './icon_upload.svg?react'
export { default as upload_line } from './icon_upload_line.svg?react'
export { default as verified_user } from './icon_verified_user.svg?react'
export { default as video } from './icon_video.svg?react'
export { default as volume_high } from './icon_volume_high.svg?react'
export { default as volume_mute } from './icon_volume_mute.svg?react'
export { default as width_fit } from './icon_width_fit.svg?react'
export { default as zoom_in } from './icon_zoom_in.svg?react'
export { default as check_2 } from './worksheet_option/check_2.svg?react'
export { default as check_4 } from './worksheet_option/check_4.svg?react'
export { default as check_6 } from './worksheet_option/check_6.svg?react'
export { default as check_default } from './worksheet_option/check_default.svg?react'
export { default as uncheck_2 } from './worksheet_option/uncheck_2.svg?react'
export { default as uncheck_4 } from './worksheet_option/uncheck_4.svg?react'
export { default as uncheck_6 } from './worksheet_option/uncheck_6.svg?react'
export { default as uncheck_default } from './worksheet_option/uncheck_default.svg?react'
